import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Col, Row, Text, useTheme } from '@metaicg/sensei-ui';
import { Link } from 'react-router-dom';
import LanguageSelector from '@/shared/components/language-selector';
import { AuthProfileState } from '@/shared/hooks/use-auth-profile';
import Avatar from '@/shared/components/avatar';
import { ROUTE_PATHS } from '@/routes';
import styles from './styles';

const ProfileMenuContainer = styled.div(styles.profileMenuContainer);

interface ProfileMenuProps {
  data?: AuthProfileState;
  logoutHandler: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const ProfileMenu = ({ data, logoutHandler }: ProfileMenuProps) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <ProfileMenuContainer>
      <Row gutter={theme.spacing.xs} wrap={false}>
        <Col flex="50px">
          <Avatar alt={data?.displayName || ''} src={data?.profilePhoto} />
        </Col>
        <Col flex="auto">
          <Row gutter={[0, theme.spacing.xxs]}>
            <Col span={24}>
              <Text size="sm" className="profile-name">
                {data?.displayName}
              </Text>
            </Col>
            <Col span={24}>
              <Text size="sm" className="profile-email" color="neutral.palette300">
                {data?.email}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row align="middle">
        <Col>
          <nav aria-label="Profile">
            <ul>
              <li>
                <Text as="label" size="sm">
                  {t('common:components.language.preferredLanguage')}
                </Text>
                <LanguageSelector />
              </li>
              <li>
                <Text as={Link} to={ROUTE_PATHS.profile.edit} size="sm">
                  {t('common:components.nav.profile.edit')}
                </Text>
              </li>
              <li>
                <Text
                  as={Link}
                  size="sm"
                  title="Logout"
                  aria-label="Logout"
                  to={ROUTE_PATHS.login}
                  onClick={logoutHandler}
                >
                  {t('common:components.nav.profile.logout')}
                </Text>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>
    </ProfileMenuContainer>
  );
};

export default ProfileMenu;
